import type { DeepUnwrap } from '../../../index'
import type { ApprovalsStatusSettingsType } from './approvals'

/**
 * Status identifiers supported by custom workflows.
 *
 * These values must stay aligned with the database's `statuses_type_enum`.
 */
export const WORKFLOW_STATUS_TYPES = ['approvals'] as const

/**
 * A persisted custom-workflow status identifier.
 */
export type StatusType = (typeof WORKFLOW_STATUS_TYPES)[number]

/**
 * A union of all possible status type settings.
 */
export type StatusSettingsType = ApprovalsStatusSettingsType

/**
 * A utility type to help set up status settings for kysely types.
 *
 * @example
 * export type StatusType =
 *  | 'approvals'
 *  ...
 *  | 'reviews'
 * @example
 * export type ReviewsStatusSettingsType = SetupStatus<{
 *  // documentation about the status behaviors
 *  type: 'reviews',
 *  ...properties
 * }>
 * @example
 * export type StatusSettingsType =
 *  | ApprovalsStatusSettingsType
 *  ...
 *  | ReviewsStatusSettingsType
 */
export type SetupStatus<T extends { type: StatusType }> = DeepUnwrap<T>
